import React, { useState } from 'react';
import './PasswordPrompt.css';

export const PasswordPrompt = ({ error, onSubmit }) => {
  return (
    <div className="password-prompt">
      <h1>Gallery</h1>
      <form onSubmit={event => {event.preventDefault();onSubmit(event.target.elements.password.value)}}>
        <h2>Enter Passcode</h2>
        <div className="form-item">
          <input name="password" placeholder="Enter Passcode" pattern="\d*" minLength={4} maxLength={8} required />
        </div>
        {error && <div className="error">{error}</div>}
        <div className="buttons">
          <button type="submit">Submit</button>
        </div>
      </form>
    </div>
  );
};